/* unplugin-vue-components disabled */import script from "./Icon.vue?vue&type=script&setup=true&lang=ts"
export * from "./Icon.vue?vue&type=script&setup=true&lang=ts"

import "./Icon.vue?vue&type=style&index=0&id=22f9258b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22f9258b"]])

export default __exports__